import { Skeleton } from '@ibsys/kit';
import { cn } from '@/shared/lib';

export function SkeletonAudio({ className = '' }: { className?: string }) {
  return (
    <div className={cn('flex gap-0.5 w-full h-4 items-center overflow-hidden shrink-0', className)}>
      {Array(20).fill(
        <>
          <Skeleton className={'h-1/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-2/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-3/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-4/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-8/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-10/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-8/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-4/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-3/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-2/10 w-0.5 shrink-0 bg-primary'} />
          <Skeleton className={'h-1/10 w-0.5 shrink-0 bg-primary'} />
        </>,
      )}
    </div>
  );
}
